'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactCodemirror = require('react-codemirror2');

var _fragment = require('@dekk/fragment');

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Code = function (_Component) {
  _inherits(Code, _Component);

  function Code() {
    _classCallCheck(this, Code);

    return _possibleConstructorReturn(this, (Code.__proto__ || Object.getPrototypeOf(Code)).apply(this, arguments));
  }

  _createClass(Code, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _styles2.default)();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          ranges = _props.ranges,
          order = _props.order,
          options = _props.options,
          children = _props.children;
      var steps = ranges.length;

      return _react2.default.createElement(
        _fragment.Sequence,
        { order: order, steps: steps },
        function (index, time, timeline) {
          var renderChildren = function renderChildren() {
            if (typeof children === 'function') {
              return children(index, time, timeline);
            }
            return children;
          };
          return _react2.default.createElement(_reactCodemirror.UnControlled, {
            className: '__dekk-code__',
            value: renderChildren(),
            options: options,
            selection: {
              ranges: ranges[index]
            }
          });
        }
      );
    }
  }], [{
    key: 'defaultProps',
    get: function get() {
      return {
        order: 0,
        ranges: undefined,
        options: undefined,
        children: 'const foo = "foo"'
      };
    }
  }, {
    key: 'propTypes',
    get: function get() {
      return {
        order: _propTypes2.default.number,
        ranges: _propTypes2.default.array,
        options: _propTypes2.default.object,
        children: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
      };
    }
  }]);

  return Code;
}(_react.Component);

exports.default = Code;